import {Text} from '@primer/react'
import {VALUES} from '../../constants/values'

export function GhostActor(): JSX.Element {
  return <Text>{VALUES.ghostUserLogin} </Text>
}

try{ GhostActor.displayName ||= 'GhostActor' } catch {}